// extracted by mini-css-extract-plugin
var _1 = "HuJLduSFMR_hH7jXZLL8";
var _2 = "CSzMr2dmPjvw3i1ZAz4A";
export { _1 as "badge", _2 as "pending" }
